import i18next from 'i18next';
import { COOKIE_TICKET_NAME } from '~/constants/hosts';
import { NotificationT } from '~/libs/soopI18n';

const errorMessage = NotificationT(
    '오류가 발생하였습니다. 잠시 후 다시 이용해주세요.'
);

export const getDefaultErrorMessage = () =>
    i18next.t(errorMessage) || errorMessage;

/**
 * 쿠키 key 로 찾아서 값을 반환한다
 * @param {string} cname - 쿠키 이름
 * @returns 쿠키 값
 */
export const getCookie = (cname: string) => {
    if (typeof document !== 'undefined') {
        const name = cname + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    }
    return '';
};

export const isLogin = () => {
    return getCookie(COOKIE_TICKET_NAME);
};
